/** ==========================================================================
 *  Import ES6 Modules (https://webpack.js.org/api/module-methods/)
 *  =========================================================================*/

import { CheckoutDataController } from './components/checkoutDataController';
import CheckoutSummaryController from "./components/checkoutSummaryController";
import { Locations } from './components/Locations';
import DialogHandler from './components/DialogHandler';
import BumperballLocationHandler from './components/BumperballLocationHandler';
import axios from 'axios'

import {KAL} from '@komma/kal';
KAL.options.rootMargin = '0px 0px -100px 0px';
KAL.init();

window.axios = axios.create()
window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN' : document.querySelector('meta[name="csrf-token"]').getAttribute('content')
}
/** ==========================================================================
 *  Dependencies
 *  =========================================================================*/

/**
 * External
 */
require('hammerjs');
require('objectFitPolyfill');

/**
 * Global / Shared with KMS
 */
require('./../global/polyfills/eventPolyFill');
require('./../global/polyfills/isInteger');
require('./../global/polyfills/promise');
require('./../global/polyfills/remove');

/** ==========================================================================
 *  Global functionalities
 *  =========================================================================*/

require('./global/helpers'); // Should be first
require('./global/browserHandler');
require('./global/scrollHandler');
require('./global/toggleHandler');

/** ==========================================================================
 *  Component functionalities
 *  =========================================================================*/


require('./components/categoryHandler');
require('./components/ActivitySwiper');
require('./components/FoodSwiper');
require('./components/chocolateFactory');
require('./components/cookieHandler');
require('./components/LogoSliderHandler');
require('./components/mapsHandler');
require('./components/overlayMenuHandler');
require('./components/projectorHandler');
require('./components/scrollToHandler');
require('./components/locationMapHandler');
require('./components/toggleHandler');
require('./components/youtubeHandler');
require('./components/datePickerHandler');
// require('./components/modalHandler');
require('./components/searchFormHandler');
require('./components/ReadMore');
require('./components/ProductActionSticky');



new CheckoutDataController();


document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-dialog-open').forEach(button => {
        const dialogIndex = button.getAttribute('data-dialog-index');

        const dialog = document.querySelector(`.js-dialog[data-dialog-index="${dialogIndex}"]`);

        const dialogHandler = new DialogHandler(dialog);

        button.addEventListener('click', (event) => {
            event.preventDefault();
            dialogHandler.openDialog();
        });
    });
});

document.querySelectorAll('.js-locations').forEach((parentElement) => new Locations(parentElement));
new BumperballLocationHandler();
/** ==========================================================================
 *  Vue Shopping Cart
 *  =========================================================================*/
import { createApp, ref } from 'vue'
import {appendTranslations} from "./services/useTranslations"
import ReadMore from "./components/ReadMore";


let shoppingCartEl = document.querySelector('.js-cart');
if (shoppingCartEl) {
    import(/* webpackChunkName: "cart" */ "./components/ShoppingCart").then(({default: ShoppingCart}) => {
        new ShoppingCart(shoppingCartEl)
    })
}


let activitySwipers = document.querySelectorAll('.js-activity-swiper');

if (activitySwipers) {
    document.addEventListener('DOMContentLoaded', () => {
        import(/* webpackChunkName: "reviews" */ "./components/ActivitySwiper").then(({default: ActivitySwiper}) => {
            activitySwipers.forEach((parentElement) => new ActivitySwiper(parentElement));
        })
    })
}


let foodSwiper = document.querySelectorAll('.js-main-food-wrapper-swiper');

if (foodSwiper) {
    document.addEventListener('DOMContentLoaded', () => {
        import(/* webpackChunkName: "reviews" */ "./components/FoodSwiper").then(({default: FoodSwiper}) => {
            foodSwiper.forEach((parentElement) => new FoodSwiper(parentElement));

        })
    })
}



let imageBannerEl = document.querySelector('.js-image-banner-swiper');
if (imageBannerEl) {
    import(/* webpackChunkName: "imageBanner" */ "./components/ImageBanner").then(({default: ImageBanner}) => {
        new ImageBanner(imageBannerEl)
    })
}


let logoSwiper = document.querySelector('.js-logo-swiper');
if (logoSwiper) {
    document.addEventListener('DOMContentLoaded', () => {
        import(/* webpackChunkName: "reviews" */ "./components/LogoSliderHandler").then(({default: LogoSliderHandler}) => {
            new LogoSliderHandler(logoSwiper)

        })
    })
}


let reviewsSwiper = document.querySelector('.js-reviews-slider');
if (reviewsSwiper) {
    document.addEventListener('DOMContentLoaded', () => {
        import(/* webpackChunkName: "reviews" */ "./components/ReviewsSliderHandler").then(({default: ReviewsSliderHandler}) => {
            new ReviewsSliderHandler(reviewsSwiper)
        })
    })
}


let checkoutSummaryFormEl = document.querySelector('.js-checkout-summary');
if (checkoutSummaryFormEl) {
    import(/* webpackChunkName: "checkoutSummary" */ "./components/checkoutSummaryController").then(({default: CheckoutSummary}) => {
        new CheckoutSummary(checkoutSummaryFormEl)
    })
}

let productImageSwiper = document.querySelector('.js-product-image-slider');
if (productImageSwiper) {

    import(/* webpackChunkName: "reviews" */ "./components/ProductImageSwiper").then(({default: ProductImageSwiper}) => {
        new ProductImageSwiper(productImageSwiper)
    })
}

const readMoreDescription =  document.querySelector('.js-read-more-content');
const readMoreToggle = document.querySelector('.js-read-more-toggle');

if (readMoreToggle) {
    import(/* webpackChunkName: "reviews" */ "./components/ReadMore").then(({default: ReadMore}) => {
        new ReadMore(readMoreDescription, readMoreToggle);
    })
}



let activeProduct = ref(null);
let sessionDate = ref(null);
let sessionLocation = ref(null);

let planModal = document.getElementById('planModal')
let planButtons = document.querySelectorAll('.js-plan-popup');

if(planButtons.length > 0) {
    if(!planModal) throw new Error('Plan buttons found but Plan modal element is missing')

    if(planModal.dataset.location) sessionLocation.value = planModal.dataset.location
    if(planModal.dataset.date) sessionDate.value = planModal.dataset.date

    appendTranslations(JSON.parse(planModal.dataset.translations))
    delete planModal.dataset.translations

    import(/* webpackChunkName: "booking" */ "./components/PlanModal").then(({default: PlanModal}) => {

        planButtons.forEach((button) => {

            button.addEventListener('click', function () {

                const clickProductId = parseInt(event.currentTarget.dataset.productId)

                if(activeProduct.value === clickProductId) activeProduct.value = null
                else activeProduct.value = clickProductId
            })
        })

        createApp({
            components: {PlanModal},
            data() {
                return {
                    activeProduct,
                    sessionDate,
                    sessionLocation,
                }
            }
        }).mount(planModal);
    })
}
